// extracted by mini-css-extract-plugin
export default {"section":"ME8v1UEw1KGrRVaDhAxW","anchor":"EnFqwJadzLKg5MEOzCby"};